define('AwaLabs.CustomerCategory', [
    'CustomerCategory.Categories',
    'CustomerCategory.Categories.Model',
    'CustomerCategory.Facets.Browse.View'
], function AwaLabsCustomerCategory() {});
